<template>
  <sTooltip
    :border="false"
    :enterable="false"
    placement="bottom"
    type="white">
    <div
      v-if="text || $slots.text"
      slot="content"
      :data-qa="`${hintQa || 'tooltiped-btn'}-hint`"
      :style="hintMaxWidth ? { maxWidth: hintMaxWidth } : null">
      <slot name="text">
        <div>{{ text }}</div>
      </slot>
    </div>
    <sButton
      :color="color"
      :disabled="disabled"
      :icon="loading ? 'loading' : icon"
      :icon-class="iconClass"
      :icon-size="icon_size ? `${icon_size}px` : null"
      :loading="loading"
      :small="smallBtn"
      type="text"
      v-on="!texted && text ? { ...open } : ''"
      @click.stop="ev => $emit('click', ev)">
      <template v-if="texted">
        {{ typeof texted == 'string' ? texted : text }}
      </template>
    </sButton>
  </sTooltip>
</template>

<script>
import { modalMixin } from 'mixins'
export default {
  name: 'tooltipedBtn',
  mixins: [modalMixin ],
  props: {
    open: [Object, Function],
    /**
     * Кнопка не активна
     */
    disabled: Boolean,
    /**
     * Иконка для кнопки
     */
    icon: String,
    /**
     * текст для подсказки
     */
    text: String,
    /**
     * Префікс data-qa тіла підказки: `${hintQa || 'tooltiped-btn'}-hint`
     */
    hintQa: String,
    /**
     * Максимальна ширина тіла підказки (CSS-значення, напр. `280px`); без значення ширина не обмежується
     */
    hintMaxWidth: String,
    /**
     * текст для кнопки
     */
    texted: [Boolean, String],

    /**
     * цвет иконки
     */
    color: {
      type: String,
      default: 'var(--text-color)'
    },
    /**
     * Индикатор загрузки
     */
    loading: {
      type: Boolean
    },
    /**
     * Маленькая кнопка
     */
    smallBtn: {
      type: Boolean
    },
    icon_size: [String, Number],
    iconClass: String,
  }
}
</script>
